import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import PostLink from "./post-link";

const Container = tw.div``;

const PostList = ({
  pageData: {
    allMarkdownRemark: { edges },
  },
}) => {
  const Posts = edges
    .filter((edge) => !!edge.node.frontmatter.date)
    .map((edge) => (
      <PostLink
        key={edge.node.id}
        to={edge.node.frontmatter.slug}
        title={edge.node.frontmatter.title}
        date={edge.node.frontmatter.date}
        summary={edge.node.excerpt}
        imgSrc={edge.node.frontmatter?.image?.childImageSharp?.fluid}
      >
        {edge.node.frontmatter.title}
      </PostLink>
    ));
  return (
    <>
      <Container>{Posts}</Container>
    </>
  );
};

PostList.propTypes = {
  pageData: PropTypes.object,
};

export default PostList;
